import { TCreateSubCategoryAction, CreateSubCategoryActionTypes } from './createSubCategoryActions';
import { ICreateSubCategoryState } from './createSubCategoryContext';

export const createSubCategoryReducer = (
	state: ICreateSubCategoryState,
	action: TCreateSubCategoryAction,
): ICreateSubCategoryState => {
	switch (action.type) {
		case CreateSubCategoryActionTypes.CHANGE_VISIBLE_FORM:
			return {
				...state,
				visibleForm: action.payload.visibleForm,
			};
		case CreateSubCategoryActionTypes.SET_FILE_ID:
			return {
				...state,
				fileId: action.payload.fileId,
			};
		case CreateSubCategoryActionTypes.SET_FETCHED_CUSTOMERS:
			return {
				...state,
				fetchedCustomers: action.payload.customers,
			};
		case CreateSubCategoryActionTypes.SET_ID_CUSTOMER:
			return {
				...state,
				IDSelectedCustomer: action.payload.IDSelectedCustomer,
				fetchedRestaurants: [],
				IDsSelectedRestaurant: [],
				fetchedCategories: [],
				IDSelectedCategory: null,
				IDsOfRestaurantsWhereToHide: [],
				IDsOfRestaurantsAvailableForRepetition: [],
				defaultCustomerLanguage: null,
				selectedTranslationTab: null,
				translations: [],
			};
		case CreateSubCategoryActionTypes.SET_FETCHED_RESTAURANTS:
			return {
				...state,
				fetchedRestaurants: action.payload.restaurants,
			};
		case CreateSubCategoryActionTypes.SET_IDS_RESTAURANT:
			return {
				...state,
				IDsSelectedRestaurant: action.payload.IDsSelectedRestaurant,
				IDsOfRestaurantsWhereToHide: action.payload.IDsOfRestaurantsWhereToHide,
				IDsOfRestaurantsAvailableForRepetition: action.payload.IDsOfRestaurantsAvailableForRepetition,
				fetchedCategories: [],
				IDSelectedCategory: null,
			};
		case CreateSubCategoryActionTypes.CHANGE_NAME_OF_SUBCATEGORY:
			return {
				...state,
				nameOfSubCategory: action.payload.nameOfSubCategory,
			};
		case CreateSubCategoryActionTypes.SET_FETCHED_CATEGORIES:
			return {
				...state,
				fetchedCategories: action.payload.categories,
			};
		case CreateSubCategoryActionTypes.SET_ID_CATEGORY:
			return {
				...state,
				IDSelectedCategory: action.payload.IDSelectedCategory,
			};
		case CreateSubCategoryActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case CreateSubCategoryActionTypes.SHOW_ERROR_MODAL_WITH_INFO:
			return {
				...state,
				errorResponse: action.payload.errorResponseData,
			};
		case CreateSubCategoryActionTypes.SET_IDS_OF_RESTAURANTS_WHERE_TO_HIDE:
			return {
				...state,
				IDsOfRestaurantsWhereToHide: action.payload.IDsOfRestaurantsWhereToHide,
			};
		case CreateSubCategoryActionTypes.SET_IDS_OF_RESTAURANTS_AVAILABLE_FOR_REPETITION:
			return {
				...state,
				IDsOfRestaurantsAvailableForRepetition: action.payload.IDsOfRestaurantsAvailableForRepetition,
			};
		case CreateSubCategoryActionTypes.CHANGE_ACTIVATION_SCHEDULE:
			return {
				...state,
				activationSchedule: action.payload.activationSchedule,
			};
		case CreateSubCategoryActionTypes.CHANGE_DEACTIVATION_SCHEDULE:
			return {
				...state,
				deactivationSchedule: action.payload.deactivationSchedule,
			};
		case CreateSubCategoryActionTypes.SET_FETCHED_TRANSLATIONS:
			return {
				...state,
				translations: action.payload.translations,
				defaultCustomerLanguage: action.payload.defaultCustomerLanguage,
			};
		case CreateSubCategoryActionTypes.SET_TRANSLATION_TAB:
			return {
				...state,
				selectedTranslationTab: action.payload.selectedTranslationTab,
			};
		case CreateSubCategoryActionTypes.CHANGE_TRANSLATION:
			return {
				...state,
				translations: action.payload.translations,
			};
		case CreateSubCategoryActionTypes.SET_DATA_FOR_SUBMIT:
			return {
				...state,
				dataForSubmit: action.payload.dataForSubmit,
			};
		case CreateSubCategoryActionTypes.RESET_FIELDS:
			return {
				...state,
				fileId: null,
				fetchedCustomers: [],
				IDSelectedCustomer: null,
				fetchedRestaurants: [],
				IDsSelectedRestaurant: [],
				nameOfSubCategory: '',
				fetchedCategories: [],
				IDSelectedCategory: null,
				IDsOfRestaurantsWhereToHide: [],
				IDsOfRestaurantsAvailableForRepetition: [],
				activationSchedule: '',
				deactivationSchedule: '',
				defaultCustomerLanguage: null,
				selectedTranslationTab: null,
				translations: [],
				dataForSubmit: null,
				typeOfModalWindow: null,
				errorResponse: null,
			};
		default:
			return state;
	}
};
